import { AssetManager } from "./manager/AssetManager"
// export * from "./manager/AssetManager"

export var assets = {
    AssetManager
};